import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import _ from 'lodash';
import hasRESTClient from '../../hocs/has-rest-client';
import withUserInfo from '../../hocs/has-user-info';
import CampaignSummary from '../../components/campaign-summary';

const delay = ms => new Promise((resolve, reject) => setTimeout(resolve, ms));

const reportsMonths = [
  'MATTER_OF_FACT_2025',
];

const getTotals = (rows, totalPosts = 1, isEMV = false) => {
  const reachTotal = _.sumBy(_.values(rows), row => _.get(row, 'totals.reach'));
  const impressionsTotal = _.sumBy(_.values(rows), row => {
    const value = _.get(row, 'totals.impressions');
    if (!isEMV || value > 0) {
      return value;
    }
    return _.get(row, 'emv.estimatedImpressions', 0);
  });
  const engagementsTotal = _.sumBy(_.values(rows), row => _.get(row, 'totals.engagements'));
  const videoViewsTotal = _.sumBy(_.values(rows), row => _.get(row, 'totals.videoViews'));
  const impsEMVTotal = _.sumBy(_.values(rows), row => {
    const value = _.get(row, 'emv.impressionsEMV');
    if (!isEMV || value > 0) {
      return value;
    }
    return _.get(row, 'emv.estimatedImpressionsEMV', 0);
  });
  const engsEMVTotal = _.sumBy(_.values(rows), row => _.get(row, 'emv.engagementsEMV'));
  const impressionsCPM = _.meanBy(_.values(rows), row => _.get(row, 'costs.impressionsCPM', 0));
  const engagementsCPM = _.meanBy(_.values(rows), row => _.get(row, 'costs.engsCPM', 0));
  const viewsCPM = _.meanBy(_.values(rows), row => _.get(row, 'costs.viewsCPM', 0));

  const engagedPosts = _.filter(rows, row => (_.get(row, 'totals.engagements') > 0))

  const aveER = _.meanBy(_.values(engagedPosts), row => {
    if ( _.get(row, 'totals.engagements') > 0 ) {
      return (_.get(row, 'totals.engagements') / _.get(row, 'instagramCount', 1) / _.get(row, 'trackedAssetsStats.totalAssets', 1)) * 100
    }
    return 0
  });

  return {
    reachTotal,
    impressionsTotal,
    engagementsTotal,
    videoViewsTotal,
    impsEMVTotal,
    engsEMVTotal,
    impressionsCPM,
    engagementsCPM,
    viewsCPM,
    aveER
  };
};

class ElevenMeadowDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      reportsData: [],
      reportsData: [],
      isLoading: true,
    };
    const { buildRESTClient } = this.props;
    this.reportImportClient = buildRESTClient({
      baseURL: process.env.REACT_APP_SHARE_API_URL || '',
      hasToken: false,
      timeout: 100000,
    });
  }


  fetchReportForMonth = async (month, reloading = false) => {
    const {
      reportsData,
    } = this.state;

    const { userInfo: { organisationId } } = this.props;
    const params = reloading ? { clearCache: true } : {};
    await this.reportImportClient.get(`/organisation/${organisationId}/report/${month}`, { params }).then(response => {
      const reports = _.get(response, 'data.data.data.reports', []);
      console.log('reports get', reports);
      
      const rData = []

      for (const report of reports) {

        const cData = getTotals(_.get(report, 'emvData.reportData'))
        cData.campaignName = _.get(report, 'name')
        cData.id = _.get(report, 'id')

        rData.push(cData)
      }

      reportsData.push({
          campaignName: _.replace(month, '_', ' '),
          campaignsData: rData,
        })

      this.setState({
        reportsData: reportsData,
        isLoading: false
      });
    }).catch(err => {
      console.log(err)
    });
  }
  fetchReports = async () => {
    this.setState({
      augustIsLoading: true,
    });
    // eslint-disable-next-line no-restricted-syntax
    for (const month of reportsMonths) {
      // eslint-disable-next-line no-await-in-loop
      await this.fetchReportForMonth(month);
      delay(500);
    }
  }

  componentDidMount() {
    this.fetchReports();
  }

render() {
  const {
    reportsData,
    isLoading
  } = this.state;

  return (
    <div className="page">
      <div className="page-content">
        <div>
          {_.map(reportsData, (campaign, i) => (
            <CampaignSummary
              key={`${_.get(campaign, 'campaignName')} - ${i}`}
              campaigns={_.get(campaign, 'campaignsData')}
              title={_.get(campaign, 'campaignName')}
              isLoading={isLoading}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
}


ElevenMeadowDashboard.propTypes = {
  buildRESTClient: PropTypes.func.isRequired,
};

export default compose(
  hasRESTClient,
  withUserInfo,
)(ElevenMeadowDashboard);



/** WEBPACK FOOTER **
 ** ./src/containers/eleven-meadow-dashboard/index.js
 **/